import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'antd';
import Card from '../../../components/Card/Card';
import Modal from '../../../components/Modal/Modal';
import BusinessEdit from './BusinessEdit';
import { businessInfoSelector } from '../OrganisationSelectors';

function InfoField({ label, value }) {
  const display = value == null || String(value).trim() === '' ? '—' : value;
  return (
    <>
      <div className="business-info-item-title">{label}</div>
      <div className="business-info-item-value">{display}</div>
    </>
  );
}

const BusinessInfo = ({ businessInfo = {} }) => {
  const { name, legalName, registrationNumber, industryName, governance } = businessInfo;
  return (
    <Card title="Organisation Information">
      <Row gutter={40} className="business-info">
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} className="business-info-item">
          <InfoField label="Full Business Name" value={name} />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} className="business-info-item">
          <InfoField label="Trading Name" value={legalName} />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} className="business-info-item">
          <InfoField label="Business Registration Number" value={registrationNumber} />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} className="business-info-item">
          <InfoField label="Industry" value={industryName} />
        </Col>
        <Col span={24} className="business-info-item">
          <InfoField label="Governance & Regulations" value={governance} />
        </Col>
      </Row>
      <div className="btn-container">
        <Modal
          explanation
          toggle={(show) => (
            <Button type="primary" icon="edit" onClick={show}>
              Edit
            </Button>
          )}
        >
          {(hide, setExplanation) => (
            <BusinessEdit businessInfo={businessInfo} close={hide} onExplanationChange={setExplanation} />
          )}
        </Modal>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  businessInfo: businessInfoSelector(state),
});

export default connect(mapStateToProps)(BusinessInfo);
